import { IStockInput } from "Dashboard/scenes/Stock/domain/IStockInput";
import { useMemorandumLogo } from "hooks/MemorandumLogo";
import { useSelector } from "react-redux";
import { FormatDate, FormatDateShort } from "utils/dateUtils";
import {
  FormatNumberOrNull, FormatNumberWithUnitOrNull
} from "utils/numberUtils";
import { selectState } from "../inputSlice";
import "../print.scss";

const PrintStock = () => {
  const memorandumLogo = useMemorandumLogo();
  const { inputs } = useSelector(selectState);

  const totalItemsCost = inputs.reduce(
    (total, input) => total + (input.pricePerUnit ?? 0 * input.quantityAmountRemaining ?? 0),
    0
  );

  const totalDeliveryCost = inputs.reduce(
    (total, input) => total + (input.deliveryPrice ?? 0 * input.quantityAmountRemaining ?? 0),
    0
  );

  const totalPrice = totalItemsCost + totalDeliveryCost;

  return (
    <>
      <div className="logo">
        {memorandumLogo && <img src={memorandumLogo} alt="" />}
      </div>
      <h1 className="header-stock">Stanje lagera na dan:</h1>
      <div className="date">{FormatDate(new Date().toISOString())}</div>
      <table className="stock-table-size table-header">
        <tbody>
          <tr>
            <th>br. otp. rač</th>
            <th>ime</th>
            <th>dobavljač</th>
            <th>ulaz</th>
            <th>kol ostalo</th>
            <th>cena po jed. m.</th>
            <th>cena trans.</th>
            <th>datum</th>
          </tr>
        </tbody>
      </table>
      <table className="stock-table stock-table-size table-body">
        <tbody>
          {inputs &&
            inputs.map((item: IStockInput) => (
              <tr key={`${item.inputId}`}>
                <td>{item.billOfLandingId}</td>
                <td>
                  <div className="name-container">
                    <div>
                      <label className="name">{item.item.name}</label>
                    </div>
                    <label className="badge">{item.repository.shortName}</label>
                  </div>
                </td>
                <td>{item.supplier.fullName}</td>
                <td>{FormatNumberOrNull(item.quantityAmountTotal)}</td>
                <td>
                  <span>
                    <label>{FormatNumberOrNull(item.quantityAmountRemaining)}</label>
                    <label>{item.quantityUnit.name}</label>
                  </span>
                </td>
                <td className="right">{FormatNumberWithUnitOrNull(item.pricePerUnit, 'rsd')}</td>
                <td className="right">{FormatNumberWithUnitOrNull(item.deliveryPrice, 'rsd')}</td>
                <td>{FormatDateShort(item.date)}</td>
              </tr>
            ))}
        </tbody>
        <tfoot>
          <tr className="footer">
            <td></td>
            <td></td>
            <td></td>
            <td className="labelTotal">ukupno</td>
            <td className="highlight right" colSpan={2}>
              <label>{FormatNumberWithUnitOrNull(totalItemsCost, 'rsd')}</label>
            </td>
            <td className="highlight right">
              <label>{FormatNumberWithUnitOrNull(totalDeliveryCost, 'rsd')}</label>
            </td>
          </tr>
          <tr className="footer">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td className="highlight right" colSpan={3}>
              <label>{FormatNumberWithUnitOrNull(totalPrice, 'rsd')}</label>
            </td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </>
  );
};

export default PrintStock;
